import { ACTION, FPTI_SPEC } from '../../utilsV3/fptiConstants';
import { trackEventWithData } from '../../utilsV3/analytics';
import { fetcher } from '../../../utility/domUtils';

let extendSessionCalledAt = Date.now();

export const extendSessionAPI = async ({
  currentStep,
  triggerEvent = true,
} = {}) => {
  // This function is called when the user click Extend Session and when the modal closes
  // Since the modal is closed after extending the session we need the logic below to prevent
  // duplicated extendSession call
  const seconds = (Date.now() - extendSessionCalledAt) / 1000;
  if (seconds < 10) return;

  extendSessionCalledAt = Date.now();

  if (triggerEvent) {
    trackEventWithData(FPTI_SPEC.ALERT_MODAL_CONFIRM_CL, {
      action: ACTION.EXTEND_SESSION,
      step: currentStep,
      link: 'extend_session',
    });
  }

  return fetcher('/donate/api/extendSession');
};

export const addActivityListeners = (listenerFunction) => {
  document.addEventListener('mousemove', listenerFunction, {
    once: true,
    capture: true,
    passive: true,
  });
  document.addEventListener('touchstart', listenerFunction, {
    once: true,
    capture: true,
    passive: true,
  });
  document.addEventListener('keydown', listenerFunction, {
    once: true,
    capture: true,
    passive: true,
  });
};

export const removeActivityListeners = (listenerFunction) => {
  document.removeEventListener('mousemove', listenerFunction, {
    once: true,
    capture: true,
    passive: true,
  });
  document.removeEventListener('touchstart', listenerFunction, {
    once: true,
    capture: true,
    passive: true,
  });
  document.removeEventListener('keydown', listenerFunction, {
    once: true,
    capture: true,
    passive: true,
  });
};
